const useMonthColumnDivider = (columns: any, fixedColumns:any, unCheckedColumns:any = []) => {
	const defaultColumns = columns
		.filter((column:any) => !fixedColumns.includes(column.field))
		.map((column:any) => {
			return {
				checked: !unCheckedColumns.includes(column.field),
				...column,
			};
		});

	const restColumns = columns
		.filter((column:any) => fixedColumns.concat(unCheckedColumns).includes(column.field))
		.map((column:any) => {
			return {
				checked: !unCheckedColumns.includes(column.field),
				...column,
			};
		});

	return {
		defaultColumns,
		restColumns,
	};
};

export default useMonthColumnDivider;

  